import gql from "graphql-tag";

const TAG_TRACKING_RESET_AMPLIFY = gql`
  mutation updateManyOrgTagsMultipleConfigs($orgId: ID) {
    updateManyEventsTargets(
      where: { orgs_some: { id: $orgId } }
      data: { isAmplifyDefault: false }
    ) {
      count
    }
  }
`;

export default TAG_TRACKING_RESET_AMPLIFY;
